import { createInstance } from "../../../libs/axios/createInstance";
import { API_URL } from "../../../libs/config";
const instance = createInstance(API_URL);
export default instance;
